export default "__VITE_ASSET__c4XoZu8A__"